import { z } from "zod";
export const AppListQuery = z.object({
    connectionId: z.coerce.number().int().positive(),
    search: z.string().optional(),
    spaceId: z.string().optional(),
    canReloadOnly: z
        .union([z.boolean(), z.enum(["true", "false"]).transform((v) => v === "true")])
        .optional(),
    cursor: z.string().optional(), // opaque, forwarded from a previous page
    limit: z.coerce.number().int().min(1).max(200).default(50),
});
export const AppRow = z.object({
    // Item-system id from Qlik items endpoint.
    id: z.string(),
    // The reload-side app GUID (Qlik `resourceId`). THIS is what gets passed to
    // /api/v1/reloads — not `id`. Do not confuse them.
    appId: z.string(),
    name: z.string(),
    spaceId: z.string().nullable(),
    spaceName: z.string().nullable(),
    ownerId: z.string().nullable(),
    ownerName: z.string().nullable(),
    lastReloadTime: z.string().datetime().nullable(),
    canReload: z.boolean(),
    connectionId: z.number().int(),
    connectionName: z.string(),
    isScheduled: z.boolean(),
});
export const AppListResponse = z.object({
    data: z.array(AppRow),
    nextCursor: z.string().nullable(),
});
//# sourceMappingURL=app.js.map